import { render, staticRenderFns } from "./center_12.vue?vue&type=template&id=62440cfc&scoped=true&"
import script from "./center_12.vue?vue&type=script&lang=js&"
export * from "./center_12.vue?vue&type=script&lang=js&"
import style0 from "./center_12.vue?vue&type=style&index=0&id=62440cfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62440cfc",
  null
  
)

export default component.exports